import { XmlCursorPos, XMLCursorPositions } from './xmlCursorPos.class';
import { DomDummyNodeManager } from '../dummyNodes/domDummyNodeManager.class';
import { XmlToolbox } from '../xmlToolbox.class';
import { XmlEditorDebugger } from '../xmlEditorDebugger';

export class XmlCursorPosSetter {
  public static setFromSelection(pos: XmlCursorPos, selectionAnchorNode: Node, selectionAnchorOffset: number, debugLog: XmlEditorDebugger = null) {
    if (selectionAnchorNode !== undefined && selectionAnchorNode !== null) {
      let node = selectionAnchorNode as Element;
      if (DomDummyNodeManager.IsDummyNode(selectionAnchorNode.parentElement)) {
        // clicked inside a dummy node
        node = selectionAnchorNode.parentElement as Element;

        if (DomDummyNodeManager.IsBeforeFirstTagDummyNode(node)) {
          switch (selectionAnchorOffset) {
            case 0:
              if (debugLog) {
                debugLog.setInputSelection(`(1) cursor here: #<tag> pos 0`);
              }
              pos.SetCursor(node.parentElement, XMLCursorPositions.CursorOnCompleteNode, 0);
              return;

            case 1:
              if (debugLog) {
                debugLog.setInputSelection(`(2) cursor here: #<tag> pos 1`);
              }
              pos.SetCursor(node.parentElement, XMLCursorPositions.CursorInFrontOfNode, 0);
              return;

            default:
              throw new Error(`selectionAnchorOffset=${selectionAnchorOffset}?!?`);
          }
        }

        if (node.parentElement.childNodes.length === 2) {
          if (debugLog) {
            debugLog.setInputSelection(`(13, 14) cursor here: <tag>#</tag>`);
          }
          pos.SetCursor(node.parentElement, XMLCursorPositions.CursorInEmptyNode, 0);
          return;
        }

        if (node === node.parentElement.lastChild && selectionAnchorOffset === 1) {
          if (debugLog) {
            debugLog.setInputSelection(`(8, 12) cursor here: #</tag>, selecting complete node`);
          }
          pos.SetCursor(node.parentElement, XMLCursorPositions.CursorOnCompleteNode, 0);
          return;
        }

        const nextSibling = node.nextSibling;
        if (nextSibling) {
          if (debugLog) {
            debugLog.setInputSelection(`(3, 4, 9, 10) cursor here: #Text or here #<tag>`);
          }
          pos.SetCursor(nextSibling, XMLCursorPositions.CursorInFrontOfNode, 0);
          return;
        }

        const previousSibling = node.previousSibling;
        if (previousSibling) {
          if (debugLog) {
            debugLog.setInputSelection(`(7, 11) cursor here: Text# or here <tag>#`);
          }
          pos.SetCursor(previousSibling, XMLCursorPositions.CursorBehindNode, 0);
          return;
        }
      } else {
        // is no dummy node
        if (selectionAnchorNode.nodeType === Node.TEXT_NODE) {
          if (selectionAnchorOffset === 0) {
            if (debugLog) {
              debugLog.setInputSelection(`(6) cursor here: #Text`);
            }
            pos.SetCursor(selectionAnchorNode, XMLCursorPositions.CursorInsideTextNode, 0);
            return;
          }

          if (selectionAnchorOffset === selectionAnchorNode.textContent.length) {
            if (debugLog) {
              debugLog.setInputSelection(`(7 Alternative) cursor here: Text#`);
            }
            pos.SetCursor(selectionAnchorNode, XMLCursorPositions.CursorInsideTextNode, selectionAnchorNode.textContent.length);
            return;
          }

          if (debugLog) {
            debugLog.setInputSelection(`(5) cursor here: Text#Text`);
          }
          if (selectionAnchorOffset > selectionAnchorNode.textContent.length) {
            throw new Error(
              `selectionAnchorOffset ${selectionAnchorOffset} is > than text-lenght ${selectionAnchorNode.textContent.length} of text '${selectionAnchorNode.textContent}' `
            );
          }
          pos.SetCursor(selectionAnchorNode, XMLCursorPositions.CursorInsideTextNode, selectionAnchorOffset);
          return;
        }
      }

      // if (DomDummyNodeManager.IsDummyNode(parentElem)) {
      //     const dummyElement = parentElem;

      //     const nextSibling = parentElem.nextSibling;
      //     if (XmlToolbox.IstTextOderKommentarNode(nextSibling)) {
      //         // cursor here: #text (# = red dummyNode)
      //         pos.CursorSetzen(nextSibling, XMLCursorPositionen.CursorInnerhalbDesTextNodes, 0);
      //         return;
      //     }

      //     const previousSibling = dummyElement.previousSibling;
      //     if (!previousSibling) {
      //     //    pos.CursorSetzen(dummyElement.parentElement, XMLCursorPositionen.c, 0);
      //     }
      // }

      // switch (node.nodeType) {

      //     case Node.TEXT_NODE:

      // if (loopCount === 0) {
      //     const nextSibling = parentElem.nextSibling;
      //     if (nextSibling && nextSibling.nodeType === Node.TEXT_NODE && selectionAnchorOffset === 1) {
      //         // set cursor at start of following textnode
      //         pos.CursorSetzen(nextSibling, XMLCursorPositionen.CursorInnerhalbDesTextNodes, 0);
      //     } else {
      //         const previousSibling = parentElem.previousSibling;
      //         if (previousSibling && previousSibling.nodeType === Node.TEXT_NODE && selectionAnchorOffset === 0) {
      //             // set cursor at end of previous textnode
      //             pos.CursorSetzen(previousSibling, XMLCursorPositionen.CursorInnerhalbDesTextNodes, previousSibling.nodeValue.length);
      //         }
      //     }
      // } else {
      //     node = parentElem; // up to dummy node
      // }

      //         } else {
      //             pos.CursorSetzen(node, XMLCursorPositionen.CursorInnerhalbDesTextNodes, selectionAnchorOffset);
      //         }
      //         break;

      //     case Node.ELEMENT_NODE:
      //         if (DomDummyNodeManager.IsDummyNode(node)) {
      //             // node = parentElem; // up to parent node
      //         } else {
      //             pos.CursorSetzen(node, XMLCursorPositionen.CursorAufNodeSelbstVorderesTag);
      //         }
      //         break;

      //     default:
      //         throw new Error(`unhandled nodeType '${node.nodeType}' of node ${XmlToolbox.GetNodeDebugContext(node)}`);
      // }
    }
    console.error(
      `found no suiting cursor interpretation! For selectionAnchorNode=${XmlToolbox.GetNodeDebugContext(selectionAnchorNode)}, selectionAnchorOffset=${selectionAnchorOffset}`
    );
  }
}
